import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useTheme } from 'ThemeContext';

import { Wrapper, Content, Text } from './ErrorScreen.style';

function ErrorScreen() {
  const theme = useTheme();
  return (
    <Wrapper theme={theme.loadingScreen.wrapper}>
      <Content>
        <Text theme={theme.loadingScreen.text}>
          <FormattedMessage id='ERROR_SCREEN.SOMETHING_WENT_WRONG' />!
        </Text>
      </Content>
    </Wrapper>
  );
}

export default ErrorScreen;
